// extracted by mini-css-extract-plugin
export default {"usageContainer":"Stats_usageContainer__1Qoy-","usageTop":"Stats_usageTop__1509s"};